var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

const SvgAdd = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "18px",
    viewBox: "0 0 19 18",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "add")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5,10 C8.2373926,10.0031468 8.04198344,10.0078671 7.91377253,10.0141608 C5.63743029,10.125903 3.79439195,10.8989605 2.38465749,12.3333333 C0.0914040429,14.6666667 0.855821857,17 3.1490753,17 C4.67791093,17 6.4615525,17 8.5,17 L14,17 C15.3333333,17 16,16.3333333 16,15",
    id: "Path-30",
    stroke: "#3F366B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#3F366B",
    strokeWidth: 1.5,
    cx: 8.5,
    cy: 4.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 7,
    x2: 15,
    y2: 13,
    id: "Line-5",
    stroke: "#3F366B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 10,
    x2: 12,
    y2: 10,
    id: "Line-5",
    stroke: "#3F366B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,10 C8.66666667,10 9.33333333,10 10,10",
    id: "Path-2",
    stroke: "#3F366B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAdd, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/add.ac74e3e6.svg";
export { ForwardRef as ReactComponent };